import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PageBar, DropMenu, DropMenuTrigger } from '@tencent/spaui'
;
import { connect } from 'react-redux';
import ArticleSummery from './articleSummery';
import { getPostList } from '@/api/cgi/knowledge/index';
import actions from '@/app/actions.js';
import { reportUserBehaviorCgi } from '@/api/cgi/common';
const menudata = [
  {
    name: 'order_by',
    title: '',
    list: [
      {
        label: '默认排序',
        value: '',
        order_value: '',
      },
      {
        label: '按更新时间倒序',
        value: 'updated_at-DESCENDING',
        order_value: 'DESCENDING',
      },
      {
        label: '按创建时间正序',
        value: 'created_at-ASCENDING',
        order_value: 'ASCENDING',
      },
      {
        label: '按创建时间倒序',
        value: 'created_at-DESCENDING',
        order_value: 'DESCENDING',
      },
    ],
  },
];
class ArticleList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      catalog_id: {},
      totalSize: 0,
      page: 1,
      order_by: { order_by: '' },
      order_value: '',
      order_text: '默认排序',
      open: false,
    };
    this.getPostList = this.getPostList.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }
  componentWillUnmount() {
    // 组件卸载的时候清空下id 防止出现第一次挂载请求两次
    this.props.dispatch({
      type: actions.knowledgeTypes.catalogId,
      response: {},
    });
  }
  componentWillReceiveProps(nextProps) {
    const { knowledge_token = '' } = this.props.accountInfo || {};
    const Id = nextProps.Id;
    if (knowledge_token) {
      if (Id && Id !== this.props.Id) {
        this.setState(
          {
            catalog_id: { value: Id },
            totalSize: 0,
            page: 1,
          },
          (_) => this.getPostList(),
        );
      }
    }
  }
  componentDidMount() {
    const { knowledge_token = '' } = this.props.accountInfo || {};
    const id = {};
    if (knowledge_token) {
      if (this.props.Id) {
        id.value = this.props.Id;
      }
      this.setState({ catalog_id: id }, (_) => this.getPostList());
    }
  }
  handleOpen(event, open) {
    this.setState({
      open,
    });
  }
  getPostList() {
    const { knowledge_token } = this.props.accountInfo;
    const { dispatch } = this.props;
    const { page, order_by, order_value, catalog_id } = this.state;
    const data = {
      knowledge_token,
      page,
      order_by: order_by.order_by.split('-')[0],
      order_value,
    };
    if (!+catalog_id.value) {
      return false;
    }
    data.catalog_id = catalog_id.value;

    this.setState({ data: [], totalSize: 0 });
    getPostList({ data }).then((res) => {
      const { data = {}, code } = res;
      if (code == 0) {
        this.setState({
          data: data.list || [],
          totalSize: data.conf.total_num,
        });
      }
    });
  }
  handleSort(event, value, itemValue) {
    this.setState(
      {
        order_by: value,
        order_text: itemValue.label,
        order_value: itemValue.order_value,
        open: false,
      },
      (_) => this.getPostList(),
    );
  }

  handleChange(event, page) {
    this.setState(
      {
        page,
      },
      (_) => {
        this.getPostList();
      },
    );
  }
  toDetail(id, key, title) {
    const params = this.props.match.params[0];
    this.props.history.push(`/list/detail/${params ? params : ''}?id=${id}&source=知识库目录`);
  }
  render() {
    const { data, open, totalSize, page, order_text, order_by } = this.state;
    return (
      <React.Fragment>
        <div className="help_content_topbar">
          <div className="help-content_topbar_left">知识列表</div>
          <div className="help-content_topbar_right">
            <DropMenuTrigger
              open={open}
              onOpen={this.handleOpen}
              dropMenu={
                <DropMenu
                  // title='每个类型下单选'

                  value={order_by}
                  data={menudata}
                  onChange={this.handleSort}
                  className="with-checkmark"
                />
              }
            >
              <span className="sorting sorting-up">
                {order_text} <i className="spaui-icon"></i>
              </span>
            </DropMenuTrigger>
          </div>
        </div>
        <div className="help_search_page help-all">
          <div className="help_search_page_content">
            {(data || []).map((v, key) => {
              return <ArticleSummery articlesummary={v} key={`${v.post_id}${key}`} onClick={(e) => this.toDetail(v.post_id, key, v.title)} />;
            })}
          </div>
          <PageBar id="Pagebar" className="help_artical_pagebar" value={page} pageSize={20} totalSize={totalSize} showTotalPage={false} onChange={this.handleChange} />
        </div>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    accountInfo: state.knowledge.knowledge_info,
    catalogId: state.knowledge.knowledge_catalogId,
    navlist: state.knowledge.knowledge_list,
  };
}
export default withRouter(connect(mapStateToProps)(ArticleList));
